var staticLocation = require('./staticLocation')

var parseUrl = require('./parseUrl')

/**
  * 获取地址栏信息
  *
  * @return Object
  */
function locat () {
  return staticLocation ? parseUrl(staticLocation.href) : {}
}

module.exports = locat



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/locat.js
// module id = 1160
// module chunks = 75